var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconDownload",
    clipPath: "url(#clip0_7134_18971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9999 0.898438C6.33127 0.898438 6.5999 1.16707 6.5999 1.49844V6.45115L8.40637 4.79073C8.65034 4.56649 9.0299 4.58248 9.25415 4.82645C9.47839 5.07042 9.4624 5.44998 9.21843 5.67423L6.40593 8.25933C6.17637 8.47034 5.82344 8.47034 5.59387 8.25933L2.78137 5.67423C2.5374 5.44998 2.52141 5.07042 2.74566 4.82645C2.9699 4.58248 3.34946 4.56649 3.59343 4.79073L5.3999 6.45115V1.49844C5.3999 1.16707 5.66853 0.898438 5.9999 0.898438ZM1.4999 7.8878C1.83127 7.8878 2.0999 8.15643 2.0999 8.4878V9.29844C2.0999 9.62981 2.36853 9.89844 2.6999 9.89844H9.2999C9.63127 9.89844 9.8999 9.62981 9.8999 9.29844V8.4878C9.8999 8.15643 10.1685 7.8878 10.4999 7.8878C10.8313 7.8878 11.0999 8.15643 11.0999 8.4878V9.29844C11.0999 10.2926 10.294 11.0984 9.2999 11.0984H2.6999C1.70579 11.0984 0.899902 10.2926 0.899902 9.29844V8.4878C0.899902 8.15643 1.16853 7.8878 1.4999 7.8878Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7134_18971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.e7b1b196ef45a1ae8f17b7cf502b3df9.svg";
export { ForwardRef as ReactComponent };